import React from 'react'
import { Ban, Clapperboard, ExternalLink, Github, Package } from 'lucide-react'

const REEL = {
  url: 'https://www.instagram.com/reel/Dd-PScpoDju/',
  product: 'Coucou',
  classification: 'Existing OSS — not a clone',
  repo: 'https://github.com/Louis-CFM/coucou',
  deb: 'https://github.com/Louis-CFM/coucou/releases/download/linux-v0.1.1/Coucou-Linux-0.1.1-amd64.deb',
  release: 'https://github.com/Louis-CFM/coucou/releases/tag/linux-v0.1.1',
  verdict: 'SKIP',
  reason: 'Linux Tauri .deb (linux-v0.1.1) runs on Debian, but XFCE/X11 has no layer-shell overlay. Island UI needs COSMIC / KDE / Hyprland / Sway.',
}

export function ReelIntel() {
  return (
    <div className="bg-[#111827] rounded-xl border border-[#374151] overflow-hidden">
      <div className="px-6 py-4 border-b border-[#374151] flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#f59e0b] to-[#06b6d4] flex items-center justify-center shrink-0">
            <Clapperboard className="w-5 h-5 text-white" />
          </div>
          <div className="min-w-0">
            <h2 className="text-lg font-bold tracking-wide">REEL INTEL</h2>
            <p className="text-[10px] text-[#6b7280] font-mono truncate">one-off · existing tool · not a pipeline</p>
          </div>
        </div>
        <span className="px-2 py-0.5 rounded text-xs font-mono bg-[#ef4444]/10 border border-[#ef4444]/30 text-[#ef4444] shrink-0">
          {REEL.verdict}
        </span>
      </div>

      <div className="p-6 space-y-4">
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <div className="text-sm font-bold font-mono">{REEL.product}</div>
            <div className="text-[10px] text-amber-400 mt-1 tracking-wider">{REEL.classification}</div>
          </div>
          <div className="flex items-center gap-1 text-[#ef4444] shrink-0">
            <Ban className="w-4 h-4" />
            <span className="text-xs font-mono">XFCE / X11</span>
          </div>
        </div>

        <p className="text-xs text-[#9ca3af] leading-relaxed">{REEL.reason}</p>

        <dl className="grid grid-cols-1 gap-3 text-xs">
          <Row label="Reel" href={REEL.url} text={REEL.url.replace(/^https:\/\//, '')} />
          <Row label="Repo" href={REEL.repo} text="Louis-CFM/coucou" icon={Github} />
          <Row label=".deb" href={REEL.deb} text="Coucou-Linux-0.1.1-amd64.deb" icon={Package} />
          <Row label="Release" href={REEL.release} text="linux-v0.1.1" />
        </dl>
      </div>
    </div>
  )
}

function Row({
  label,
  href,
  text,
  icon: Icon,
}: {
  label: string
  href: string
  text: string
  icon?: typeof Github
}) {
  return (
    <div className="bg-[#0a0f1a] rounded-lg border border-[#374151] px-3 py-2.5 flex items-center justify-between gap-3">
      <div className="min-w-0">
        <dt className="text-[10px] uppercase tracking-wider text-[#6b7280]">{label}</dt>
        <dd className="font-mono text-[#f9fafb] truncate mt-0.5">{text}</dd>
      </div>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="px-2.5 py-1.5 text-xs bg-[#1f2937] hover:bg-[#374151] border border-[#374151] rounded-lg text-[#06b6d4] font-mono flex items-center gap-1 transition-colors shrink-0"
      >
        {Icon ? <Icon className="w-3 h-3" /> : <ExternalLink className="w-3 h-3" />}
        Open
      </a>
    </div>
  )
}
